import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgLockOpenRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14.5 9.75h1.111c1.226 0 2.222 1.009 2.222 2.25v6.75c0 1.241-.996 2.25-2.222 2.25H4.5c-1.227 0-2.222-1.009-2.222-2.25V12c0-1.241.995-2.25 2.222-2.25h8.333V7.5c0-2.485 1.99-4.5 4.445-4.5s4.444 2.015 4.444 4.5v2.531a.837.837 0 0 1-.833.844.837.837 0 0 1-.833-.844V7.5c0-1.553-1.243-2.812-2.778-2.812S14.5 5.947 14.5 7.5zM3.945 12v6.75c0 .31.248.563.555.563h11.111a.56.56 0 0 0 .556-.563V12a.56.56 0 0 0-.556-.562H4.5a.56.56 0 0 0-.555.562"
    }));
export default SvgLockOpenRegular;
